<template>
	<div class="center-wrap">
		<div class="dis-fle ali-cen">
			<div class="left bor">
				<div class="title tx-18">{{ $t('闪兑') }}</div>
				<div class="form-item" style="margin-top: 30px;">
					<div class="label dis-fle ali-cen jus-bet">
						<span>{{ $t('从') }}</span>
						<span>{{ $t('余额') }}: {{ fromBalance }}</span>
					</div>
					<div class="value">
						<el-select v-model="form.from" :placeholder="$t('请选择')" style="width: 100%;" filterable>
							<el-option v-for="item in fromList" :key="item.id" :label="item.symbol" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="form-item">
					<div class="label dis-fle ali-cen jus-bet">
						<span>{{ $t('至') }}</span>
						<span>{{ $t('余额') }}: {{ toBalance }}</span>
					</div>
					<div class="value">
						<el-select v-model="form.to" :placeholder="$t('请选择')" style="width: 100%;" filterable>
							<el-option v-for="item in toList" :key="item.id" :label="item.symbol" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>

				<div class="form-item" style="margin-top: 30px;">
					<div class="label">{{ $t('兑换数量') }}</div>
					<div class="value">
						<el-input v-model="form.amount" :placeholder="$t('请输入兑换数量')">
							<template slot="suffix">
								<div class="dad" @click="allCk">{{ $t('全部') }}</div>
							</template>
						</el-input>
					</div>
				</div>

				<el-button class="btn" type="primary" @click="submit">{{ $t('兑换') }}</el-button>
			</div>
			<div class="right">
				<div class="hover-img">
					<img alt="" src="https://api.shengge975.com/upload/1744730195821558.png">
				</div>
			</div>
		</div>
		<!-- {{ exchangeData }} -->
		<tableMode ref="tableModeRef"></tableMode>
	</div>
</template>

<script>
import tableMode from './table.vue';
import apis from '@/http/api'
import { get, post } from '@/http/request'
export default {
	components: {
		tableMode
	},
	data() {
		return {
			exchangeData: [],
			form: {
				from: '', //产品id
				to: '', //产品id
				amount: '', //金额
			},
		};
	},
	watch: {
		'form.from'() {
			this.form.to = ''
		},
	},
	computed: {
		fromBalance() {
			let arr = this.exchangeData || []
			let id = this.form.from
			let list = arr.filter(item => item.id === id)
			if (list.length > 0) {
				return list[0].value
			}
			return 0
		},
		toBalance() {
			let arr = this.exchangeData || []
			let id = this.form.to
			let list = arr.filter(item => item.id === id)
			if (list.length > 0) {
				return list[0].value
			}
			return 0
		},
		fromList() {
			let arr = this.exchangeData || []
			let id = this.form.to
			return arr.filter(item => item.id !== id)
		},
		toList() {
			let arr = this.exchangeData || []
			let id = this.form.from
			return arr.filter(item => item.id !== id)
		},
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			this.getData()
			this.initTable()
		},
		getData() {
			get(apis.exchangeData, {}).then(res => {
				if (res.code != 1) return
				this.exchangeData = res.data

				if (this.exchangeData.length > 0) {
					this.form.from = this.exchangeData[0].id
				}
			})
		},
		submit() {
			post(apis.exchangeSubmit, this.form).then(res => {
				if (res.code != 1) return
				this.form.amount = ''
				this.$notify.success(res.msg)

				this.init()
			})
		},
		allCk() {
			this.form.amount = this.fromBalance
		},
		initTable() {
			this.$refs.tableModeRef.init()
		}
	},
};
</script>
<style lang="scss" scoped>
.center-wrap {
	padding: 50px 0px;
}

.left {
	width: 520px;
	min-height: 470px;

	::v-deep .el-input--small .el-input__inner {
		height: 40px;
		line-height: 40px;
	}

	.title {
		// margin-bottom: 20px;
	}

	.btn {
		width: 100%;
		line-height: 38px;
		height: 38px;
		border-radius: 50px;
		font-size: 16px;
		padding: 0px;
		margin-top: 50px;
	}

	.form-item {
		.label {
			font-size: 14px;
			line-height: 32px;
		}

		.value {
			margin-bottom: 10px;
		}
	}

	.dad {
		height: 100%;
		display: flex;
		align-items: center;
		color: #07ecfe;
		cursor: pointer;
		padding-right: 16px;
	}
}

.right {
	flex: 1;
	margin-left: 30px;
	border-radius: 12px;
	background: url('~@/assets/img-pc/125.e20cb355.png') no-repeat;
	background-size: 100% 100%;
	min-height: 470px;

	.hover-img {
		width: 80%;
		height: 100px;
		margin: 143px auto 0;
		border-radius: 12px;
		background: rgba(44, 44, 52, .23);
		-webkit-backdrop-filter: blur(6px);
		backdrop-filter: blur(6px);
		font-size: 50px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			height: 90px;
		}
	}
}

.bor {
	border: 2px solid #2c2c3e;
	padding: 20px 30px 30px;
	border-radius: 12px;
}
</style>